import { supabase } from "@/integrations/supabase/client";
import { handleSupabaseFunctionError } from "@/utils/supabaseFunctionsError";
import type { Sector } from "@/types/risk-analysis";

export interface GetSectorsParams {
  context?: string;
}

export async function getSectors(params?: GetSectorsParams): Promise<Sector[]> {
  let url = "api/get-sectors";

  if (params?.context) {
    const queryParams = new URLSearchParams({ context: params.context });
    url = `${url}?${queryParams.toString()}`;
  }

  const { data, error } = await supabase.functions.invoke(url, {
    method: "GET",
  });

  await handleSupabaseFunctionError(error);
  return data;
}
